import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import TrackerAddMeal from '../components/TrackerAddMeal';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeDietMeal } from '../helpers/normalizers';
import { DietMealProps } from '../types';

const TrackerAddDietMealContainer: React.FC<DietMealProps> = (props) => {
  const normalizedProps = normalizeDietMeal(props);
  return (
    <TrackerAddMeal
      key={normalizedProps.mealData.id}
      {...normalizedProps}
      mode="backward-navigation"
    />
  );
};

export default withLoading(TrackerAddDietMealContainer, UniversalPlaceholder);
